// Centralized, stable-keyed strings for the accessibility launcher/panel —
// kept out of the components themselves so a future translation layer can
// swap this module without touching component internals (see spec's
// internationalization-readiness requirements). Not itself an i18n library;
// just a single flat lookup table.
export const accessibilityMessages = {
  openPanel: 'Open display and accessibility preferences',
  closePanel: 'Close display and accessibility preferences',
  panelTitle: 'Display and accessibility',
  panelDescription:
    'Adjust how this website is displayed on this device. These preferences do not change the unit’s saved website design.',
  reset: 'Reset preferences',
  done: 'Done',
  textSize: 'Text size',
  textSizeDefault: 'Site default',
  textSizeLarge: 'Large',
  textSizeExtraLarge: 'Extra large',
  textSpacing: 'Text spacing',
  textSpacingDefault: 'Site default',
  textSpacingIncreased: 'Increased',
  textSpacingMaximum: 'Maximum supported',
  contentSpacing: 'Content spacing',
  contentSpacingDefault: 'Site default',
  contentSpacingComfortable: 'Comfortable',
  contentSpacingExpanded: 'Expanded',
  contrast: 'Contrast',
  contrastDefault: 'Site default',
  contrastHighLight: 'High-contrast light',
  contrastHighDark: 'High-contrast dark',
  readableFont: 'Readable font',
  readableFontDescription: 'Use a simple, highly legible system font.',
  highlightLinks: 'Highlight links',
  highlightLinksDescription: 'Add a persistent underline to links in text.',
  enhancedFocus: 'Enhanced focus visibility',
  enhancedFocusDescription: 'Show a thicker, more visible outline around the focused item.',
  reduceMotion: 'Reduce motion',
  reduceMotionDescription: 'Turn off nonessential animations and transitions.',
  pauseAnimations: 'Pause moving content',
  pauseAnimationsDescription: 'Pause carousels, banners, and other automatically animated content.',
} as const;

export type AccessibilityMessageKey = keyof typeof accessibilityMessages;
